// Auto generated file, do not manually modify!
// com.hotpads.clientappconfig.web.handler.web.ClientAppConfigWebHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

interface GetAllFeaturesParams {
  appName: string;
}
interface GetFeatureParams {
  appName: string;
  featureName: string;
}

export const ClientAppConfigWebHandler_getAllFeatures_Path = '/api/web/v1/appConfig/getAllFeatures';

/**
 * Get all app configuration for an application
 */
export const ClientAppConfigWebHandler_getAllFeatures = (getParams: GetAllFeaturesParams, client = getClient()) => {
  return httpFrontEndRequest<GetAllFeaturesParams, never, Record<string, string>>(
    {
      getParams: getParams,
      endpoint: ClientAppConfigWebHandler_getAllFeatures_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const ClientAppConfigWebHandler_getFeature_Path = '/api/web/v1/appConfig/getFeature';

/**
 * Get app configuration feature for an application
 */
export const ClientAppConfigWebHandler_getFeature = (getParams: GetFeatureParams, client = getClient()) => {
  return httpFrontEndRequest<GetFeatureParams, never, string>(
    {
      getParams: getParams,
      endpoint: ClientAppConfigWebHandler_getFeature_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
